export const FETCH_PAYMENTS_REQUEST = 'FETCH_PAYMENTS_REQUEST' as const;
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS' as const;
export const FETCH_PAYMENTS_FAILURE = 'FETCH_PAYMENTS_FAILURE' as const;
export const PAYMENT_METHODS_UPDATE = 'PAYMENT_METHODS_UPDATE' as const;
export const PAYMENT_METHODS_FAILURE_UPDATE = 'PAYMENT_METHODS_FAILURE_UPDATE' as const;
export const PAYMENT_METHODS_DELETE = 'PAYMENT_METHODS_DELETE' as const;
export const PAYMENT_METHODS_ADD = 'PAYMENT_METHODS_ADD' as const;
export const PAYMENT_METHODS_MAKE_DEFAULT = 'PAYMENT_METHODS_MAKE_DEFAULT' as const;
export const PAYMENT_METHODS_RESET = 'PAYMENT_METHODS_RESET' as const;
export const PAYMENT_METHODS_RESET_ERROR = 'PAYMENT_METHODS_RESET_ERROR' as const;
export const PAYMENT_INITIALS_LOADING = 'PAYMENT_INITIALS_LOADING' as const;
export const PAYMENT_INITIALS_LOADED = 'PAYMENT_INITIALS_LOADED' as const;

export const PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST = 'PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST' as const;